import React from 'react';
import DetailItem from 'components/Layout/DetailItem';

const EducationSection = ({ labelPrefix, details }) => {
  if (!details?.course) return null;

  return (
    <>
      <div className="col-md-3 col-sm-6 col-12">
        <DetailItem
          label={`Course Name (${labelPrefix})`}
          value={details.course}
        />
      </div>
      <div className="col-md-3 col-sm-6 col-12">
        <DetailItem label="Department" value={details.department} />
      </div>
      <div className="col-md-6 col-sm-12 col-12">
        <DetailItem label="University" value={details.university} />
      </div>
      <div className="col-md-6 col-sm-12 col-12">
        <DetailItem label="Institution" value={details.institution} />
      </div>
      <div className="col-md-3 col-sm-6 col-12">
        <DetailItem
          label="Year of Completion"
          value={details.year_of_completion}
        />
      </div>
      <hr />
    </>
  );
};

export default EducationSection;
